import React, { Fragment } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import { HeaderWarpPc, HeaderWarpM } from './style.js'
import { message } from 'antd'
import { connect } from 'react-redux'
import { actions } from './store'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuFlag: false,
      openArr: null,
      search: '',
      data: null,
      app_Id: null,
      times_tamp: null,
      nonce_Str: null,
      _url: null,
    }
  }
  menuOpen() {
    this.setState(state => ({
      menuFlag: !state.menuFlag
    }));
  }
  menuClose() {
    let self = this
    document.body.addEventListener(
      'click',
      function (e) {
        function matchesSelector(element, selector) {
          if (element.matches) {
            return element.matches(selector)
          } else if (element.matchesSelector) {
            return element.matchesSelector(selector)
          } else if (element.webkitMatchesSelector) {
            return element.webkitMatchesSelector(selector)
          } else if (element.msMatchesSelector) {
            return element.msMatchesSelector(selector)
          } else if (element.mozMatchesSelector) {
            return element.mozMatchesSelector(selector)
          } else if (element.oMatchesSelector) {
            return element.oMatchesSelector(selector)
          }
        }

        //匹配当前组件内的所有元素
        if (matchesSelector(e.target, '.nav_bg *')) {
          return
        }
        // 匹配菜单打开元素
        if (matchesSelector(e.target, '.menu_btn *')) {
          return
        }

        self.setState({
          menuFlag: false,
        })
      },
      false
    )
  }
  componentDidMount() {
    window_link = '/' + '#' + this.props.location.pathname
    var ua = navigator.userAgent.toLowerCase() //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      if (window.location.href != window_link) {
        location.href = window_link
      }
    }
    this.props.setHistory(this.props.location.pathname)
    window.addEventListener('hashchange', () => {
      this.setState({
        menuFlag: false,
      })
      window_link =
        '/' + '#' + this.props.location.pathname
      this.props.setHistory(this.props.location.pathname)
    })
    React.$request({
      url:'Portal/index/is_open',
      method:'get',
    }).then(res=>{
      this.setState({
        openArr: res.data,
      })
    })
  }
  submitSearch() {
    if (this.state.search) {
      // this.props.history.push('/search/' + this.state.search)
      window.location.href = `/#/search/` + this.state.search
      this.setState({
        search: '',
      })
    } else {
      message.info('请输入搜索内容')
    }
  }
  ipt_name(e) {
    this.setState({
      search: e.target.value,
    })
  }
  render() {
    return (
      <Fragment>
        <HeaderWarpPc>
          {/* 换肤-PC端-头部背景 */}
          <img className="header_bg" src='/img/skin/header_2024_04_02.png' alt="" />
          <div className="header">
            <NavLink className="logo" to="/home">
              {/* 换肤-logo */}
              <img src="/img/skin/logo_2024_04_02.png" alt="" />
            </NavLink>
            {/* {
                                this.state.openArr?
                                <div className="is_open_message">
                                    <i><img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/header_06.png" alt=""/></i>
                                    <span className="today">
                                        {this.state.openArr.create_name == '今日开馆'?this.state.openArr.create_name+'  '+this.state.openArr.create_time + '-'+this.state.openArr.end_time:'今日闭馆'}
                                    </span>
                                    <i className="line">
                                        <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/header_15.png" alt=""/>
                                    </i>
                                    <span className="tommorow">
                                    {this.state.openArr.end_name == '明日开馆'?this.state.openArr.end_name+'  '+this.state.openArr.create_time + '-'+this.state.openArr.end_time:'明日闭馆'}
                                    </span>
                                </div>:null
                            } */}
            <div className="search">
              <input
                type="text"
                className="search_ipt"
                value={this.state.search}
                onChange={this.ipt_name.bind(this)}
                onKeyUp={(e) => (e.keyCode === 13 ? this.submitSearch() : null)}
              />
              <div
                className="search_btn"
                onClick={this.submitSearch.bind(this)}
              >
                {/* 换肤-icon-放大镜 */}
                <svg t="1612749590480" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2231" width="64" height="64"><path d="M1005.281763 914.755286L806.759734 716.297255A447.986525 447.986525 0 1 0 0 448.017324a447.986525 447.986525 0 0 0 716.266456 358.773209l198.394033 198.394033a63.998075 63.998075 0 1 0 90.621274-90.42928zM447.986525 767.943702A319.990375 319.990375 0 1 1 447.986525 128.026949a319.990375 319.990375 0 0 1 0 639.980751z" fill="#1f8879" p-id="2232"></path></svg>
              </div>
            </div>
            <div className='lang-box'>
              <span>中文</span>
              <a
                  href={`${process.env.REACT_APP_IMGBASE}/en/index.html`}
                  className="mpyd"
                  // target="_blank"
                  rel="noopener noreferrer"
              >
                EN
                {/* ENGLISH */}
                {/*<svg t="1619590835200" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4167" width="64" height="64"><path d="M921.590246 0H102.398916C45.846285 0 0.000903 45.843575 0.000903 102.398013v819.202168c0 56.556244 45.845382 102.398013 102.398013 102.398013h819.193137c56.563469 0 102.407044-45.843575 102.407044-102.398013V102.398013C1023.999097 45.843575 978.155522 0 921.590246 0zM516.575146 727.549335H197.680437V308.279575h310.875109v70.908439H282.319732v92.982208h210.492832v70.657374H282.319732v114.062558h234.255414v70.659181z m310.871496 0h-80.351338v-155.002256c0-32.799081-1.717712-54.027541-5.13146-63.654674a44.548518 44.548518 0 0 0-16.758075-22.435012 47.698559 47.698559 0 0 0-27.895204-8.019601c-13.911478 0-26.358114 3.802085-37.448282 11.45683-11.057656 7.613202-18.672664 17.715369-22.742069 30.308309-4.096499 12.594746-6.142942 35.87868-6.142942 69.783166v137.565044H550.625935V423.819618h74.640081v44.620767c26.50803-34.336171 59.854395-51.468133 100.078832-51.468133 17.758718 0 33.938804 3.184359 48.614311 9.54766 14.686345 6.413874 25.812637 14.536429 33.319272 24.457974 7.542759 9.921546 12.811492 21.159824 15.73395 33.75457 2.935101 12.594746 4.436067 30.602722 4.436067 54.074503l-0.001806 188.742376z" fill="#74c0f2" p-id="4168"></path></svg>*/}
              </a>
            </div>
            <a
              href="http://ticket.bjsc.net.cn/"
              className="hdbm"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* 换肤-icon-门票 */}
              {/* <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/header_10.png" alt="" /> */}
              <svg t="1612749741584" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2995" width="64" height="64"><path d="M995.677124 830.496905 995.677124 830.52915 995.677124 830.52915 995.677124 927.264575 995.677124 927.264575 995.677124 959.477472C995.677124 995.108353 966.785477 1023.967755 931.18684 1023.967755L92.81316 1023.967755C57.214523 1023.967755 28.322876 995.140598 28.322876 959.509716L28.322876 959.509716 28.322876 959.509716C28.322876 959.477472 28.322876 959.477472 28.322876 959.477472L28.322876 894.987189 28.322876 894.987189 28.322876 894.987189C28.322876 894.987189 28.322876 894.987189 28.322876 894.987189L28.322876 830.496905C99.552394 830.496905 157.303442 772.778102 157.303442 701.548584 157.303442 630.383557 99.681374 572.696998 28.580838 572.568017L28.322876 572.568017 28.322876 572.535773C28.322876 572.535773 28.322876 572.535773 28.322876 572.535773L28.322876 508.045489C28.322876 508.045489 28.322876 508.045489 28.322876 508.045489L28.322876 508.045489 28.322876 508.045489 28.322876 443.555206C28.322876 431.656749 31.773106 420.661156 37.383761 411.116594 38.834792 393.639727 47.47649 377.033479 63.728041 367.617898L684.543753 7.439666C710.920278-7.876776 744.648696 1.216354 759.868404 27.72186L787.438 75.702631 764.73742 88.890893 769.219494 88.890893C775.120356 84.312083 780.827746 79.572048 787.438 75.702631L815.007596 123.683402C762.286789 154.316286 744.197264 222.063328 774.636678 275.074341 805.108337 328.085355 872.565173 346.239369 925.318225 315.63873L952.887821 363.619501C945.826135 367.714633 938.538733 370.874657 931.18684 373.647739L931.18684 376.195105 952.887821 363.619501 968.849166 391.414813C985.036227 403.119799 995.677124 422.047697 995.677124 443.555206L995.677124 475.832593 995.677124 475.832593 995.677124 572.568017 995.419162 572.568017C924.318626 572.696998 866.696558 630.383557 866.696558 701.548584 866.696558 772.778102 924.447606 830.496905 995.677124 830.496905ZM726.881624 302.772918C692.798509 243.409612 699.344273 171.760908 737.715991 120.136436L737.715991 99.983223 712.113349 55.420437 154.240154 379.064923 824.294196 379.064923C784.664917 367.553407 749.163016 341.499333 726.881624 302.772918ZM931.18684 519.911701 931.18684 508.045489 931.18684 508.045489 931.18684 443.555206 92.81316 443.555206 92.81316 443.587451 92.81316 443.587451 92.81316 519.911701C167.783114 546.546189 221.793726 617.421009 221.793726 701.548584 221.793726 785.643913 167.783114 856.518734 92.81316 883.153222L92.81316 959.477472 931.18684 959.477472 931.18684 894.987189 931.18684 894.987189 931.18684 883.153222C856.216886 856.518734 802.206274 785.643913 802.206274 701.548584 802.206274 617.421009 856.216886 546.546189 931.18684 519.911701ZM528.122571 862.774292 495.877429 862.774292C486.97777 862.774292 479.754859 855.519135 479.754859 846.619476L479.754859 814.374334C479.754859 805.474676 486.97777 798.251764 495.877429 798.251764L528.122571 798.251764C537.02223 798.251764 544.245141 805.474676 544.245141 814.374334L544.245141 846.619476C544.245141 855.519135 537.02223 862.774292 528.122571 862.774292ZM528.122571 733.76148 495.877429 733.76148C486.97777 733.76148 479.754859 726.538569 479.754859 717.63891L479.754859 685.393768C479.754859 676.494109 486.97777 669.271198 495.877429 669.271198L528.122571 669.271198C537.02223 669.271198 544.245141 676.494109 544.245141 685.393768L544.245141 717.63891C544.245141 726.538569 537.02223 733.76148 528.122571 733.76148ZM528.122571 604.780914 495.877429 604.780914C486.97777 604.780914 479.754859 597.558002 479.754859 588.658344L479.754859 556.413202C479.754859 547.513543 486.97777 540.290631 495.877429 540.290631L528.122571 540.290631C537.02223 540.290631 544.245141 547.513543 544.245141 556.413202L544.245141 588.658344C544.245141 597.558002 537.02223 604.780914 528.122571 604.780914ZM431.129184 314.413415 455.022834 300.548003C461.600844 296.743076 470.016826 299.000236 473.853997 305.642736L487.622672 329.600876C491.4276 336.243375 489.17044 344.723847 482.592431 348.561019L458.698781 362.394184C452.120772 366.231357 443.672545 363.941952 439.867619 357.331698L426.098942 333.341313C422.261771 326.698813 424.551176 318.250586 431.129184 314.413415Z" p-id="2996" fill="#1f8879"></path></svg>
              门票预约
            </a>
            <a href="https://www.bast.net.cn/col/col35862/index.html"
              className="hdbm02"
              target="_blank"
              rel="noopener noreferrer">数字科协服务管理平台</a>
          </div>
          <div className="nav_bg">
            <div className="nav">
              <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/home"
              >
                首页
              </NavLink>
              <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/library"
              >
                本馆信息
              </NavLink>
              <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/service"
              >
                参观服务
              </NavLink>
              <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/exhibition"
              >
                展览展示
              </NavLink>
              <a className="headerNav" href={`/recent/scienceClassroom/home`}>科学课堂</a>
              <a className="headerNav" href={`/recent/SciencePopularActivity/home`}>科普活动</a>
              <a className="headerNav" href={`/recent/ScienceContest/home`}>科技竞赛</a>
              {/* <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/education"
              >
                教育活动
              </NavLink>
              <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/cinema"
              >
                特效影院
              </NavLink> */}
              <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/communication"
              >
                交流合作
              </NavLink>
              {/* <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/train"
              >
                科普培训
              </NavLink> */}
              <NavLink
                activeClassName="selected"
                className="headerNav"
                to="/partyMasses"
              >
                党群园地
              </NavLink>
            </div>
          </div>
        </HeaderWarpPc>
        <HeaderWarpM>
          <div className="addny">
            {/* 换肤-移动端-头图 */}
            <img src='/img/skin/m_header_2024_04_02.png'/>
          </div>
          <div className="header" onClick={(e) => this.menuClose()}>
            {/* {
                                this.state.openArr?
                                <div className="is_open_message">
                                    <div className="today">
                                        {this.state.openArr.create_name == '今日开馆'?this.state.openArr.create_name+' '+this.state.openArr.create_time + ''+this.state.openArr.end_time:'今日闭馆'}
                                    </div>
                                    <div className="tommorow">
                                        {this.state.openArr.end_name == '明日开馆'?this.state.openArr.end_name+' '+this.state.openArr.create_time + ''+this.state.openArr.end_time:'明日闭馆'}
                                    </div>
                                </div>:null
                            } */}
            <NavLink className="logo" to="/home">
              {/* 换肤-logo */}
              <img src="/img/skin/logo_2024_04_02.png" alt="" />
            </NavLink>
            <div className="search">
              <input
                type="text"
                className="search_ipt"
                value={this.state.search}
                onChange={this.ipt_name.bind(this)}
                onKeyUp={(e) => (e.keyCode === 13 ? this.submitSearch() : null)}
              />
              <div
                className="search_btn"
                onClick={this.submitSearch.bind(this)}
              >
                {/* 换肤-移动端-门票icon */}
                {/* <img src={`${process.env.REACT_APP_IMGBASE}/administrator/data/upload/portal/resource/img/header/header_08.png" alt="" /> */}
                {/*<svg t="1612749590480" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2231" width="64" height="64"><path d="M1005.281763 914.755286L806.759734 716.297255A447.986525 447.986525 0 1 0 0 448.017324a447.986525 447.986525 0 0 0 716.266456 358.773209l198.394033 198.394033a63.998075 63.998075 0 1 0 90.621274-90.42928zM447.986525 767.943702A319.990375 319.990375 0 1 1 447.986525 128.026949a319.990375 319.990375 0 0 1 0 639.980751z" fill="#b01604" p-id="2232"></path></svg>*/}
                <svg t="1612749590480" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2231" width="64" height="64"><path d="M1005.281763 914.755286L806.759734 716.297255A447.986525 447.986525 0 1 0 0 448.017324a447.986525 447.986525 0 0 0 716.266456 358.773209l198.394033 198.394033a63.998075 63.998075 0 1 0 90.621274-90.42928zM447.986525 767.943702A319.990375 319.990375 0 1 1 447.986525 128.026949a319.990375 319.990375 0 0 1 0 639.980751z" fill="#1f8879" p-id="2232"></path></svg>
              </div>
            </div>
            <div className="menu_btn" onClick={() => this.menuOpen(1)}>
              {/* 换肤-移动端-导航按钮 */}
              <img src="/img/skin/btn_nav_2024_04_02.png" alt="" />
            </div>
          </div>
          {this.state.menuFlag ? (
            <div className="nav_bg">
              <div className="nav">
                <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/home"
                >
                  首页
                </NavLink>
                <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/library"
                >
                  本馆信息
                </NavLink>
                <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/service"
                >
                  参观服务
                </NavLink>
                <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/exhibition"
                >
                  展览展示
                </NavLink>
                <a className="headerNav" href={`/recent/scienceClassroom/home`}>科学课堂</a>
                <a className="headerNav" href={`/recent/SciencePopularActivity/home`}>科普活动</a>
                <a className="headerNav" href={`/recent/ScienceContest/home`}>科技竞赛</a>
                {/* <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/education"
                >
                  教育活动
                </NavLink>
                <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/cinema"
                >
                  特效影院
                </NavLink> */}
                <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/communication"
                >
                  交流合作
                </NavLink>
                {/* <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/train"
                >
                  科普培训
                </NavLink> */}
                <NavLink
                  activeClassName="selected"
                  className="headerNav"
                  to="/partyMasses"
                >
                  党群信息
                </NavLink>
                <a href="https://www.bast.net.cn/col/col35862/index.html"
                  activeClassName="selected"
                  className="headerNav"
                  target="_blank"
                  >数字科协<br/>服务管理<br/>平台</a>
              </div>
            </div>
          ) : null}
        </HeaderWarpM>
      </Fragment>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    history: state.getIn(['history', 'historyPath']),
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    setHistory(path) {
      dispatch(actions.SetHistory(path))
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
